import * as types from "./types";

export const setAgentsList = (payload) => (dispatch) =>
    dispatch({ type: types.SET_AGENTS_LIST, payload });
